export const HomeRoute = {
  path: '/',
  load: () => import('./Home'),
  protected: true,
};
